import { StoreUtils } from '@space-shell/common/utils/store'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { VIEW_AS_STORE_KEY } from './constants'
import type { ViewAsStoreType } from './types'
import { ViewAsFromPageType, DEFAULT_ROLE_TYPE } from './types'

const initialState = {
  isEnabled: false,
  isReadonly: false,
  from: ViewAsFromPageType.Home,
  role: DEFAULT_ROLE_TYPE
}

export const useViewAsStore = create<ViewAsStoreType>()(
  devtools(
    persist((_) => initialState, {
      name: VIEW_AS_STORE_KEY,
      partialize: (state) => {
        return StoreUtils.partialize<ViewAsStoreType>(state, ['isEnabled', 'isReadonly'])
      }
    })
  )
)
